
















































import {Component, Prop, Vue} from 'vue-property-decorator';
import ZCLogo from '../assets/logo.svg';
import {WebService} from '@/services/web.service';
import {AuthStore} from '@/store/modules/auth.store';
// @ is an alias to /src

@Component({
	components: {
		ZCLogo
	}
})
export default class ErrorOverlay extends Vue {
	host = '';
	locationBase = '';
	apiKey = '';

	async login() {
		AuthStore.setAuthCredentials({
			host: (this.host.startsWith('http') ? '' : 'https://') + this.host + (this.host.endsWith('/') ? '' : '/') + 'api/v1/location/',
			locationBase: this.locationBase,
			apiKey: this.apiKey
		});
	}
}
